<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useUserStore } from "./stores/user.store";
import { useRouter, useRoute } from "vue-router";
import { IsUserLoggedIn } from "./lib/auth";

const userStore = useUserStore();
const router = useRouter();
const route = useRoute();

onMounted(async () => {
  if(route.meta.requiresNotSignedIn === true) {
    if(userStore.signedIn || userStore.userId || userStore.userEmail) {
      return router.push("/");
    }
  }
  // Validate session
  if(route.meta.requiresAuth === true || route.meta.requiresAuth === undefined) {
    if(!userStore.signedIn || !userStore.userId || !userStore.userEmail) {
      return router.push("/login");
    }

    const isAuthenticated = await IsUserLoggedIn(userStore.userId, userStore.userEmail);
    if(!isAuthenticated) {
      return router.push("/login");
    }
  }
});
</script>

<style lang="scss">
@use "@/assets/styles/main.scss";
</style>